<template>
<div id="pageTable">
    <v-container grid-list-xl fluid>
        <v-layout row wrap>
            <v-flex sm12>
                <v-card>
                    <v-toolbar card color="white">
                        <v-toolbar-title>
                            <h3>Aggregator</h3>
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <router-link class="link-btn square-btn" :to="{name: 'EquipmentsList'}">
                            <v-icon color="black" medium>fa-chevron-left</v-icon>
                        </router-link>
                    </v-toolbar>
                    <breadcrumbs :items="breadcrumbs" divider=">"></breadcrumbs>
                    <v-divider></v-divider>
                        <v-flex lg12  xs12 text-xs-right>
                            <v-btn slot="activator" href="/static/equipments_code.csv" download color="orange darken- white--text">
                                <v-icon>fa fa-download</v-icon>  &nbsp;  &nbsp; Download Sample File
                            </v-btn>
                        </v-flex>
                    <v-card-text class="pa-0">
                        <v-form class="ldmx-form">
                            <v-container grid-list-xl fluid>
                                <v-layout row wrap>
                                    <v-flex lg12 md12 xs12>
                                        <v-text-field label="Aggregator Name *" v-model="form.name" :maxlength="32" v-validate="{required: form.name, max: 32, no_special_char: 'form.name','restrictedWord':[]}" data-vv-name="name" placeholder="" :error-messages="errors.collect('name')">
                                        </v-text-field>                                        
                                    </v-flex>
                                    <v-flex lg12 md12 xs12>
                                        <v-textarea label="Description" v-model="form.description" data-vv-name="description" placeholder="" v-validate="{'restrictedWord':[]}" :error-messages="errors.collect('description')">
                                        </v-textarea>
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap>
                                    <v-flex lg12 md12 xs12>
                                        <v-btn color="orange darken-  white--text" @click="clearFormField();form.type = true;"> Add Manually </v-btn>
                                        <v-btn color="orange darken-  white--text" @click="clearFormField();form.type = false;activateDragAndDrop();"> Add CSV </v-btn>
                                    </v-flex>
                                </v-layout>
                                <template v-if="form.type">
                                    <v-layout row wrap v-for="(input, index) in equipments" :key="index">
                                        <v-flex lg4 md4 xs4>
                                            <v-text-field label="Equipment Name *" @keyup="onBlurMappedName(index)" v-model="input.mapped_name" v-validate="{required: equipments[index].mapped_name,'restrictedWord':[]}" data-vv-as="Equipment Types Name" :data-vv-name="`equipments[${index}][mapped_name]`" placeholder="" :error-messages="errors.collect(`equipments[${index}][mapped_name]`)">
                                            </v-text-field>
                                        </v-flex>
                                        <v-flex lg4 md4 xs4>
                                            <v-text-field label="Equipment Code *" @keyup="onBlurMappedCode($event,index)" v-model="input.mapped_code" v-validate="{required: equipments[index].mapped_code,'restrictedWord':[]}" data-vv-as="Equipment Types Code" :data-vv-name="`equipments[${index}][mapped_code]`" placeholder="" :error-messages="errors.collect(`equipments[${index}][mapped_code]`)">
                                            </v-text-field>
                                        </v-flex>
                                        <v-flex lg4 md4 xs4>
                                            <v-btn depressed icon fab dark color="orange" small v-if="index!=0" @click="deleteRow(index)">
                                                <v-icon color="white">delete</v-icon>
                                            </v-btn>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout row wrap v-if="equipments.length >= 1">
                                        <v-flex lg8 md8 xs8>
                                        </v-flex>
                                        <v-flex text-xs-left lg4 md4 xs4>
                                            <v-btn depressed icon fab dark color="orange" small @click="addRow">
                                                <v-icon color="white">add</v-icon>
                                            </v-btn>
                                        </v-flex>
                                    </v-layout>
                                </template>
                                <template v-else>
                                    <v-layout row wrap >
                                        <v-flex lg12 md12 customImgWrap>
                                            <div class="customImg" id="file-drag-drop">
                                                <form ref="myFiles">
                                                    <v-icon>cloud_upload</v-icon><br>
                                                    <p class="dragtxt">Drag files to upload</p>
                                                    <p class="ortxt">Or</p>
                                                    <v-btn slot="activator" color="orange darken- white--text" @click="$refs.inputUpload.click()">
                                                        <v-icon>search</v-icon>&nbsp;&nbsp;CHOOSE FILE
                                                    </v-btn>
                                                    <input v-show="false"
                                                        type="file" 
                                                        id="file" 
                                                        ref="inputUpload" 
                                                        class="custom-file-input " 
                                                        @change="onFileChange($event.target.files)"
                                                    >
                                                    <p v-if="fileObj[0]">
                                                        <strong class="link-text">     
                                                            File selected to aggregators :
                                                            <span>{{fileObj[0] ? fileObj[0].name : ''}}</span>
                                                        </strong>
                                                    </p>
                                                </form>
                                            </div>
                                        </v-flex>
                                    </v-layout>
                                </template>
                                <div class="form-btn text-xs-right">
                                    <v-btn color="gray  white--text" @click="$router.push('/equipments/list')"><v-icon color="white">fa-times-circle</v-icon>Cancel</v-btn>
                                    <v-btn color="green  white--text" @click="submit"> Save </v-btn>
                                </div>
                            </v-container>
                        </v-form>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</div>
</template>

<script>
import GoogleAds from "@/pages/widgets/GoogleAds";
import services from "../../services/HttpService";
import breadcrumbs from "../widgets/Breadcrumb";
import {Validator, ErrorBag} from 'vee-validate';
import utils from '../../util/';
import config from '../../config';
Validator.extend('uniqueMapName', {
    getMessage: field => 'Already exist',
    validate: function (value, [arrForMappedName,index]) {
        for (var key in arrForMappedName) {
            if (arrForMappedName.hasOwnProperty(key)) {
                if(index != key && arrForMappedName[key] == value){
                    return false;
                }
            }
        }
        return true;
    }
});
Validator.extend('uniqueMapCode', {
    getMessage: field => 'Already exist',
    validate: function (value, [arrForMappedCode,index,incId]) {
        for (var key in arrForMappedCode) {
            if (arrForMappedCode.hasOwnProperty(key)) {
                if(incId != arrForMappedCode[key]['inc_id'] && arrForMappedCode[key]['mapped_code'] == value){
                    return false;
                } else {
                    Validator.remove(arrForMappedCode[key]['mapped_code'])
                }
            }
        }
        return true;
    }
});

export default {
    $_veeValidate: {
        validator: "new"
    },
    beforeRouteLeave(to, from, next) {
        if (to.name === 'Login') {
            next();
        } else {
            if (this.canLeaveWithoutPrompt) {
                return next();
            }
            next(window.confirm('Do you really want to leave? You have unsaved changes!'));
        }
    },
    created() {
        this.utils = utils;
    },
    components: {
        breadcrumbs,
        GoogleAds
    },
    data() {
        return {
            canLeaveWithoutPrompt: false,
            breadcrumbs: [{
                    name: 'Dashboard',
                    to: "/dashboard",
                    disabled: false
                },
                {
                    name: 'Reporting',
                    to: "/comingsoon",
                    disabled: false
                },
                {
                    name: 'Equipment Types',
                    to: "/equipments/list",
                    disabled: false
                },
                {
                    name: 'Add Equipment Type',
                    disabled: true
                }
            ],
            form: {
                name: "",
                description: "",
                type: true,
                equipments : []
            },
            equipments : [{mapped_name: '',mapped_code: ''}],
            arrForMappedCode:{},
            arrForMappedName:{},
            bag:new ErrorBag(),
            dragAndDropCapable: false,
            allowFileExtDoc:['csv'],
            fileObj: {}
        }
    },
    mounted() {
        this.$validator.localize("en", this.dictionary);
    },
    methods: {
        _showToast(msg, color) {
            window.getApp.$emit("showSnackbar", {
                color,
                msg
            });
        },
        addRow() {
            this.equipments.push({mapped_name: '',mapped_code: ''});
        },
        checkMappedCodeValidation(index) {
            let tmpArr = [];
            for (var key in this.equipments) {
                if(tmpArr.includes(this.equipments[key]['mapped_code'])){
                    this.$validator.errors.add({
                        field: 'equipments['+index+'][mapped_code]',
                        msg: 'email is already in use'
                    });
                    tmpArr.push(this.equipments[key]['mapped_code']);
                } else {
                    tmpArr.push(this.equipments[key]['mapped_code']);
                    this.errors.remove('equipments['+index+'][mapped_code]');
                }
            }
        },
        onBlurMappedCode(data,index) {
        },
        onBlurMappedName(index) {
            this.arrForMappedName[index] = this.equipments[index].mapped_name;
        },
        deleteRow(index) {
            this.equipments.splice(index,1)
        },
        submit() {
            const self = this,
                wApp = window.getApp;
            self.$validator
                .validateAll()
                .then(isValid => {
                    if(!self.form.type && typeof self.fileObj[0] == 'undefined'){
                        self._showToast(config.errAutoloader, config.errMsgColorStr);
                        return false;
                    } else if (isValid) {
                        wApp.$emit("showLoader", {
                            show: true
                        });
                        let postData = {};
                        if(self.form.type){
                            self.form.equipments = JSON.stringify(self.equipments);
                            postData = self.form;
                            delete postData.file;
                            services.post("aggregators/new", postData, {
                                    Authorization: "Bearer " + this.$store.state.user.token
                                })
                            .then(res => {
                                wApp.$emit("showLoader", {
                                    show: false
                                });
                                if (!res.data.is_error) {
                                    self._showToast(res.data.message);
                                    self.canLeaveWithoutPrompt = true;
                                    self.$router.push("/equipments/list");
                                    // self.form = {};
                                    // self.form.type = true;
                                    // self.form.equipments = utils.equipmentCodeEmptyObj;
                                } else {
                                    self._showToast(res.data.message, "red");
                                    this.form.file = new FormData();
                                }
                            })
                            .catch(err => {
                                wApp.$emit("showLoader", {
                                    show: false
                                });
                                self._showToast(err.message, "red");
                            });
                        } else {
                            let postData = new FormData();
                            postData.append('file',self.fileObj[0]);
                            postData.append("name", self.form.name);
                            postData.append("description", self.form.description);
                            postData.append("type", self.form.type);
                            services.postFile("aggregators/new-csv", postData, {
                                'content-type': 'multipart/form-data',
                                "Authorization": "Bearer " + self.$store.state.user.token
                            })
                            .then(res => {
                                wApp.$emit("showLoader", {
                                    show: false
                                });
                                if (!res.data.is_error) {
                                    self._showToast(res.data.message);
                                    self.canLeaveWithoutPrompt = true;
                                    self.$router.push("/equipments/list");
                                } else {
                                    self._showToast(res.data.message, "red");
                                }
                            })
                            .catch(err => {
                                wApp.$emit("showLoader", {
                                    show: false
                                });
                                self._showToast(err.message, "red");
                            });
                        }
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        },
        onFileChange(file, type) {
            const self = this;
            self.fileObj = {};
            if(file.length > 0){
                self.fileValidations(file,function(res){
                    if(res){
                        self.fileObj = file;
                    }
                });
            }
        },
        fileValidations(file, cb){
            const self = this;
            let fileExtension = file[0].name.split('.').pop();
            if(!self.allowFileExtDoc.includes(fileExtension.toLowerCase())){
                self._showToast(config.incorrectFileFormat, config.errMsgColorStr);
                cb(false);
            } else {
                cb(true);
            }
        },
        determineDragAndDropCapable(){
            var div = document.createElement('div');
            return ( ( 'draggable' in div )
                    || ( 'ondragstart' in div && 'ondrop' in div ) )
                    && 'FormData' in window
                    && 'FileReader' in window;
        },
        async activateDragAndDrop(){
            if(!this.form.type){
                this.dragAndDropCapable = await this.determineDragAndDropCapable();
                if( this.dragAndDropCapable ){
                    ['drag', 'dragstart', 'dragend', 'dragover', 'dragenter', 'dragleave', 'drop'].forEach( function( evt ) {
                        this.$refs.myFiles.addEventListener(evt, function(e){
                        e.preventDefault();
                        e.stopPropagation();
                        }.bind(this), false);
                    }.bind(this));
                    this.$refs.myFiles.addEventListener('drop', function(e){
                        this.onFileChange(e.dataTransfer.files);
                    }.bind(this));
                }
            }
        },
        clearFormField(){
            const self = this;
            if(self.form.type){
                self.equipments = [{mapped_name: '',mapped_code: ''}];
            }else if(!self.form.type){
                self.fileObj = {};
            }
            self.$validator.reset();
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/pages/aggregators/Add.vue